document.addEventListener('DOMContentLoaded', function () {
var headers = document.querySelectorAll('.ms-footer-accordion-header');

headers.forEach(function (btn) {
    btn.addEventListener('click', function () {
    var target = document.querySelector(this.dataset.target);
    if (!target) return;

    var isOpen = this.classList.toggle('is-open');
    this.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    target.hidden = !isOpen;
    this.querySelector('.ms-footer-accordion-icon').textContent = isOpen ? '−' : '+';
    });
});
});